<template>
    <div>
        <!-- 主视觉横幅区 -->
        <section class="hero-gradient h-[320px] relative overflow-hidden flex items-center">
            <div class="absolute inset-0 opacity-20">
                <svg class="w-full h-full" preserveAspectRatio="none" viewBox="0 0 100 100">
                    <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white"></path>
                </svg>
            </div>
            <div class="max-w-[1200px] mx-auto px-4 relative z-10 w-full flex justify-between items-center text-white">
                <div class="space-y-6">
                    <h1 class="text-5xl font-bold">数据资产价值评估</h1>
                    数据资产价值评估，是指通过系统化的方法体系，对组织所持有的数据进行货币化或效用化的衡量与分析。随着数据被正式列为生产要素，对其价值进行科学评估已成为企业资产管理、财务规划与战略决策的核心环节。<div
                        class="flex space-x-4">
                        <button
                            class="bg-white text-blue-700 px-8 py-3 rounded-md font-bold shadow-lg hover:bg-blue-50 transition-colors">立即申请评估</button>
                        <button @click="showMessageModal = true"
                            class="border border-white/50 bg-white/10 backdrop-blur-sm px-8 py-3 rounded-md font-bold hover:bg-white/20 transition-colors">在线专家咨询</button>
                    </div>
                </div>
                <div class="hidden lg:block">
                    <span class="iconify text-[200px] text-white/30" data-icon="hugeicons:analytics-01"></span>
                </div>
            </div>
        </section>
        <!-- 价值应用场景展示区 -->
        <section class=" py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16 ">
                    <h2 class="text-3xl font-bold mb-6 text-gray-800 relative inline-block">
                        <span class="relative z-10">价值应用与赋能场景</span>
                        <div
                            class="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-Twenty h-1 bg-blue-600 rounded-full">
                        </div>
                    </h2>
                    <p class="text-gray-600 max-w-2xl mx-auto text-lg">探索数据价值在资产管理、金融赋能和商业决策中的多元化应用场景</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 value-scene-container">
                    <!-- 场景 1 -->
                    <div class="value-scene-card scene-1">
                        <div class="flex items-center space-x-4 mb-6">
                            <div
                                class="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-200">
                                <span class="iconify text-3xl text-white" data-icon="hugeicons:property-view"></span>
                            </div>
                            <h3 class="text-2xl font-bold text-blue-900">赋能资产入表</h3>
                        </div>
                        <p class="text-[#666666] mb-6 line-clamp-3">基于会计准则，将符合条件的公共数据资源确认为无形资产或存货，实现数据资源向数据资产的实质性转化。</p>
                        <ul class="space-y-3 p-4 bg-gray-50 rounded-xl">
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-blue-500 mr-2" data-icon="circle-flags:check"></span>合规性实质审查
                            </li>
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-blue-500 mr-2" data-icon="circle-flags:check"></span>成本重置核算</li>
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-blue-500 mr-2" data-icon="circle-flags:check"></span>优化资产负债结构
                            </li>
                        </ul>
                    </div>
                    <!-- 场景 2 -->
                    <div class="value-scene-card scene-2">
                        <div class="flex items-center space-x-4 mb-6">
                            <div
                                class="w-14 h-14 bg-emerald-600 rounded-xl flex items-center justify-center shadow-lg shadow-emerald-200">
                                <span class="iconify text-3xl text-white" data-icon="hugeicons:coins-01"></span>
                            </div>
                            <h3 class="text-2xl font-bold text-emerald-900">支撑融资质押</h3>
                        </div>
                        <p class="text-[#666666] mb-6 line-clamp-3">为金融机构提供客观、公允的数据估值意见，通过"数据贷"、"数据质押"等创新产品，拓宽企业融资渠道。
                        </p>
                        <ul class="space-y-3 p-4 bg-gray-50 rounded-xl">
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-emerald-500 mr-2" data-icon="circle-flags:check"></span>权威授信评分
                            </li>
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-emerald-500 mr-2" data-icon="circle-flags:check"></span>动态风险监测
                            </li>
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-emerald-500 mr-2" data-icon="circle-flags:check"></span>普惠金融精准滴灌
                            </li>
                        </ul>
                    </div>
                    <!-- 场景 3 -->
                    <div class="value-scene-card scene-3">
                        <div class="flex items-center space-x-4 mb-6">
                            <div
                                class="w-14 h-14 bg-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-purple-200">
                                <span class="iconify text-3xl text-white" data-icon="hugeicons:coins-01"></span>
                            </div>
                            <h3 class="text-2xl font-bold text-purple-900">助力交易定价</h3>
                        </div>
                        <p class="text-[#666666] mb-6 line-clamp-3">解决数据交易"定价难"痛点，通过全方位价值评估体系，为供需双方提供科学的价格参考区间。</p>
                        <ul class="space-y-3 p-4 bg-gray-50 rounded-xl">
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-purple-500 mr-2" data-icon="circle-flags:check"></span>多维估值模型对标
                            </li>
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-purple-500 mr-2" data-icon="circle-flags:check"></span>行业场景溢价分析
                            </li>
                            <li class="flex items-center text-sm text-[#444] font-medium"><span
                                    class="iconify text-purple-500 mr-2" data-icon="circle-flags:check"></span>降低市场博弈成本
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!-- 方法体系模块 -->
        <section class=" py-20  bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16 px-4">
                    <h2 class="text-3xl font-bold mb-6 text-gray-800 relative inline-block">
                        <span class="relative z-10">评估方法体系介绍</span>
                        <div
                            class="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-Twenty h-1 bg-blue-600 rounded-full">
                        </div>
                    </h2>
                    <p class="mt-6 text-gray-600 max-w-2.5xl mx-auto text-lg">依据《公共数据资源登记管理暂行办法》，构建基于成本、收益及市场的全方位度量模型
                    </p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 method-cards-container">
                    <!-- 成本法 -->
                    <div class="method-card cost-method">
                        <div class="h-2 bg-blue-500"></div>
                        <div class="p-8 flex flex-col h-full">
                            <div class="flex items-center space-x-3 mb-6">
                                <span class="text-3xl font-black text-blue-100">01</span>
                                <h4 class="text-xl font-bold">成本法</h4>
                            </div>
                            <div class="bg-blue-50/50 p-4 rounded-lg mb-6">
                                <span class="text-sm font-medium text-blue-700">核心逻辑</span>
                                <p class="text-sm mt-1">核算数据采集、治理、存储、脱敏及合规化过程中的重置全额。适合初级公共数据资源。</p>
                            </div>
                            <ul class="space-y-3 mb-8 text-sm text-[#666666] flex-grow">
                                <li class="flex items-center"><span class="iconify mr-2 text-blue-500"
                                        data-icon="mdi:check-circle"></span>采集成本核算</li>
                                <li class="flex items-center"><span class="iconify mr-2 text-blue-500"
                                        data-icon="mdi:check-circle"></span>治理与运维支出</li>
                                <li class="flex items-center"><span class="iconify mr-2 text-blue-500"
                                        data-icon="mdi:check-circle"></span>折旧与摊销系数</li>
                            </ul>
                            <!-- 成本法按钮 -->
                            <a class="method-btn cost-btn" @click="openMethodModal('cost')">查看计算细则</a>
                        </div>
                    </div>
                    <!-- 收益法 -->
                    <div class="method-card revenue-method">
                        <div class="h-2 bg-emerald-500"></div>
                        <div class="p-8 flex flex-col h-full">
                            <div class="flex items-center space-x-3 mb-6">
                                <span class="text-3xl font-black text-emerald-100">02</span>
                                <h4 class="text-xl font-bold">收益法</h4>
                            </div>
                            <div class="bg-emerald-50/50 p-4 rounded-lg mb-6">
                                <span class="text-sm font-medium text-emerald-700">核心逻辑</span>
                                <p class="text-sm mt-1">基于该资产在未来预期内带来的经济收益折现。适合已具商业模式的数据产品。</p>
                            </div>
                            <ul class="space-y-3 mb-8 text-sm text-[#666666] flex-grow">
                                <li class="flex items-center"><span class="iconify mr-2 text-emerald-500"
                                        data-icon="mdi:check-circle"></span>未来现金流量预测</li>
                                <li class="flex items-center"><span class="iconify mr-2 text-emerald-500"
                                        data-icon="mdi:check-circle"></span>数据分成率（IR）</li>
                                <li class="flex items-center"><span class="iconify mr-2 text-emerald-500"
                                        data-icon="mdi:check-circle"></span>风险折现率确定</li>
                            </ul>
                            <!-- 收益法按钮 -->
                            <a class="method-btn revenue-btn" @click="openMethodModal('revenue')">查看收益模型</a>


                        </div>
                    </div>
                    <!-- 市场法 -->
                    <div class="method-card market-method">
                        <div class="h-2 bg-purple-500"></div>
                        <div class="p-8 flex flex-col h-full">
                            <div class="flex items-center space-x-3 mb-6">
                                <span class="text-3xl font-black text-purple-100">03</span>
                                <h4 class="text-xl font-bold">市场法</h4>
                            </div>
                            <div class="bg-purple-50/50 p-4 rounded-lg mb-6">
                                <span class="text-sm font-medium text-purple-700">核心逻辑</span>
                                <p class="text-sm mt-1">参考同类数据交易案例或公开市场成交价进行修正。适合标准化的交易型数据。</p>
                            </div>
                            <ul class="space-y-3 mb-8 text-sm text-[#666666] flex-grow">
                                <li class="flex items-center"><span class="iconify mr-2 text-purple-500"
                                        data-icon="mdi:check-circle"></span>可比案例筛选</li>
                                <li class="flex items-center"><span class="iconify mr-2 text-purple-500"
                                        data-icon="mdi:check-circle"></span>时点差值修正</li>
                                <li class="flex items-center"><span class="iconify mr-2 text-purple-500"
                                        data-icon="mdi:check-circle"></span>体量与场景权重</li>
                            </ul>

                            <!-- 市场法按钮 -->
                            <a class="method-btn market-btn" @click="openMethodModal('market')">查看对标标准</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 评估标准与流程 -->
        <section class="bg-white py-20 ">
            <div class="border-y border-gray-100">
                <div class="max-w-[1200px] mx-auto px-4">
                    <div class="text-center mb-16">
                        <h2 class="text-3xl font-bold mb-6 text-gray-800 relative inline-block">
                            <span class="relative z-10">评估标准与流程体系</span>
                            <div
                                class="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-Twenty h-1 bg-blue-600 rounded-full">
                            </div>
                        </h2>
                        <p class="text-gray-600 max-w-2xl mx-auto text-lg">遵循国家标准与专业流程，确保评估结果的权威性与可靠性</p>
                    </div>
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-16">
                        <!-- 左侧：评估标准 -->
                        <div>
                            <h3 class="text-2xl font-bold mb-8 flex items-center">
                                <span
                                    class="w-8 h-8 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center mr-3 text-sm font-bold">A</span>
                                权威性标准体系
                            </h3>
                            <div class="w-full h-80 mb-6" id="chart-pie"></div>

                            <!-- PDF预览区域 -->
                            <div class="space-y-4">
                                <!-- 第一行：两个并排 -->
                                <div class="flex flex-col md:flex-row gap-4">
                                    <div class="flex-1 flex items-center p-4 bg-gray-50 rounded-lg border border-gray-100 cursor-pointer hover:bg-gray-100 transition-colors"
                                        @click="previewFile('Account-2023-21.pdf')">
                                        <span class="iconify text-2xl text-red-500 mr-4"
                                            data-icon="vscode-icons:file-type-pdf2"></span>
                                        <div class="flex-1">
                                            <p class="font-bold text-sm">会计[2023]21号</p>
                                            <p class="text-xs text-[#999999]">企业数据资源相关会计处理暂行规定</p>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex items-center p-4 bg-gray-50 rounded-lg border border-gray-100 cursor-pointer hover:bg-gray-100 transition-colors"
                                        @click="previewFile('Guiding_Opinions.pdf')">
                                        <span class="iconify text-2xl text-red-500 mr-4"
                                            data-icon="vscode-icons:file-type-pdf2"></span>
                                        <div class="flex-1">
                                            <p class="font-bold text-sm">中评协</p>
                                            <p class="text-xs text-[#999999]">数据资产评估指导意见</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- 第二行：独占一排 -->
                                <div class="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-100 cursor-pointer hover:bg-gray-100 transition-colors"
                                    @click="previewFile('GBT-40685-2021.pdf')">
                                    <span class="iconify text-2xl text-red-500 mr-4"
                                        data-icon="vscode-icons:file-type-pdf2"></span>
                                    <div class="flex-1">
                                        <p class="font-bold text-sm">GB/T 40685-2021</p>
                                        <p class="text-xs text-[#999999]">信息技术 数据资产价值评估指南</p>
                                    </div>
                                    <!-- 预览按钮（始终显示） -->
                                    <button
                                        class="ml-4 px-3 py-1 bg-blue-400 text-white text-xs font-medium rounded-md hover:bg-blue-700 transition-colors"
                                        @click.stop="previewFile('GBT-40685-2021.pdf')">
                                        预览
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- 右侧：评估流程图 -->
                        <div>
                            <h3 class="text-2xl font-bold mb-10 flex items-center">
                                <span
                                    class="w-8 h-8 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center mr-3 text-sm">B</span>
                                全闭环评估流程
                            </h3>
                            <div class="space-y-12 relative">
                                <div
                                    class="absolute left-6 top-2 bottom-2 w-0.5 bg-dashed border-l border-dashed border-blue-200">
                                </div>
                                <div class="flex items-start relative z-10">
                                    <div
                                        class="w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold flex-shrink-0 shadow-lg shadow-blue-200">
                                        1</div>
                                    <div class="ml-6 pt-2">
                                        <h5 class="font-bold text-[#333]">需求受理与预评估</h5>
                                        <p class="text-sm text-[#666666] mt-1">提交登记公示证明，初步核定数据规模与质量基准。</p>
                                    </div>
                                </div>
                                <div class="flex items-start relative z-10">
                                    <div
                                        class="w-12 h-12 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold flex-shrink-0 shadow-lg shadow-blue-100">
                                        2</div>
                                    <div class="ml-6 pt-2">
                                        <h5 class="font-bold text-[#333]">多维质量分析</h5>
                                        <p class="text-sm text-[#666666] mt-1">调用系统组件对数据完整性、时效性、稀缺性进行量化打分。</p>
                                    </div>
                                </div>
                                <div class="flex items-start relative z-10">
                                    <div
                                        class="w-12 h-12 rounded-full bg-blue-400 text-white flex items-center justify-center font-bold flex-shrink-0 shadow-lg shadow-blue-100">
                                        3</div>
                                    <div class="ml-6 pt-2">
                                        <h5 class="font-bold text-[#333]">场景价值映射</h5>
                                        <p class="text-sm text-[#666666] mt-1">匹配行业应用场景，测算在该场景下的潜在增值空间。</p>
                                    </div>
                                </div>
                                <div class="flex items-start relative z-10">
                                    <div
                                        class="w-12 h-12 rounded-full bg-blue-300 text-white flex items-center justify-center font-bold flex-shrink-0">
                                        4</div>
                                    <div class="ml-6 pt-2">
                                        <h5 class="font-bold text-[#333]">估值模型推算</h5>
                                        <p class="text-sm text-[#666666] mt-1">综合成本、收益、市场三端模型，输出最终评估区间值。</p>
                                    </div>
                                </div>
                                <div class="flex items-start relative z-10">
                                    <div
                                        class="w-12 h-12 rounded-full bg-[#E0E0E0] text-gray-600 flex items-center justify-center font-bold flex-shrink-0">
                                        5</div>
                                    <div class="ml-6 pt-2">
                                        <h5 class="font-bold text-[#333]">出具官方评估报告</h5>
                                        <p class="text-sm text-[#666666] mt-1">加盖服务平台电子签章，作为资产入表与交易决策的权威依据。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 评估报告示例区 -->
        <section class=" py-20 text-center  bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <h2 class="text-3xl font-bold mb-6 text-gray-800 relative inline-block">
                    <span class="relative z-10">权威报告示例</span>
                    <div
                        class="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-Twenty h-1 bg-blue-600 rounded-full">
                    </div>
                </h2>
                <p class="text-gray-600 max-w-2xl mx-auto text-lg mb-12">参考真实评估案例，了解专业报告的内容构成与价值呈现</p>
                <div
                    class="flex flex-col lg:flex-row items-center gap-12 bg-gray-50 p-12 rounded-3xl border border-gray-200">
                    <div class="w-full lg:w-1/2 flex justify-center">
                        <div class="relative group cursor-zoom-in">
                            <img alt="Detailed report cover simulation showing platform logo and certification seal"
                                class="w-[320px] shadow-2xl rounded-sm border border-gray-200" id="1"
                                :src="require('@/assets/news_imgs/report_cover.png')" />
                            <div
                                class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity rounded-sm">
                                <span class="iconify text-white text-5xl" data-icon="ph:magnifying-glass-plus"></span>
                            </div>
                        </div>
                    </div>
                    <div class="w-full lg:w-1/2 text-left space-y-6">
                        <div class="bg-blue-600 text-white text-xs px-3 py-1 rounded inline-block">标准版示范报告</div>
                        <h4 class="text-2xl font-bold"> 保定市王成兰食品有限公司 - 食品生产运营及供应链数据价值评估</h4>
                        <p class="text-[#666666] text-sm leading-relaxed">
                            本报告基于食品生产运营及供应链全链路数据展开价值评估。评估充分考量了该数据在提升生产效率、优化库存周转、加强风险预警及保障食品安全等方面的高频应用与关键作用，最终形成涵盖数据获取与治理成本核算、业务增效价值量化、行业对标分析以及潜在市场价值在内的综合评估报告。
                        </p>
                        <div class="grid grid-cols-2 gap-4">
                            <div class="bg-white p-4 rounded-xl border border-gray-200">
                                <p class="text-xs text-[#999999] mb-1">评估价值区间</p>
                                <p class="text-2xl font-black text-blue-700">¥ 1.2M - 1.5M</p>
                            </div>
                            <div class="bg-white p-4 rounded-xl border border-gray-200">
                                <p class="text-xs text-[#999999] mb-1">价值等级</p>
                                <p class="text-2xl font-black text-emerald-600">AAAA</p>
                            </div>
                        </div>
                        <!-- <div class="pt-4 flex space-x-4">
                            <button
                                class="bg-[#1565C0] text-white px-8 py-3 rounded-md font-bold hover:bg-[#0D47A1] transition-all flex items-center">
                                <span class="iconify mr-2" data-icon="hugeicons:download-04"></span>
                                下载报告模板 (PDF)
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
        </section>


        <!-- 在线留言弹窗 -->
        <div v-if="showMessageModal"
            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div class="bg-white rounded-2xl w-full max-w-md shadow-2xl">
                <!-- 弹窗头部 -->
                <div class="flex items-center justify-between p-6 border-b border-gray-100">
                    <div class="flex items-center space-x-3">
                        <div class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-[#1565C0]">
                            <span class="iconify text-xl" data-icon="ri:message-3-line"></span>
                        </div>
                        <h3 class="text-xl font-bold text-gray-800">专家咨询</h3>
                    </div>
                    <button @click="showMessageModal = false"
                        class="text-gray-400 hover:text-gray-600 transition-colors">
                        <span class="iconify text-2xl" data-icon="ri:close-line"></span>
                    </button>
                </div>

                <!-- 表单内容 -->
                <div class="p-6">
                    <form @submit.prevent="submitMessage" class="space-y-5">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">姓名 <span
                                    style="color: red;">*</span></label>
                            <input v-model="messageForm.name" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入您的姓名">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">联系方式 <span
                                    style="color: red;">*</span></label>
                            <input v-model="messageForm.contact" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入手机号或邮箱">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">公司/机构</label>
                            <input v-model="messageForm.company" type="text"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入公司或机构名称（选填）">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">咨询内容 <span
                                    style="color: red;">*</span></label>
                            <textarea v-model="messageForm.content" required rows="4"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                                placeholder="请简要描述您的数据资产价值评估咨询需求..."></textarea>
                        </div>

                        <div class="pt-2">
                            <button type="submit" :disabled="isSubmitting"
                                class="w-full bg-[#1565C0] text-white py-3 rounded-lg font-bold hover:bg-[#0D47A1] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                <span v-if="!isSubmitting">提交咨询</span>
                                <span v-else class="flex items-center justify-center">
                                    <span class="iconify animate-spin mr-2" data-icon="ri:loader-4-line"></span>
                                    提交中...
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- 提交成功提示 -->
        <div v-if="showSuccessToast" class="fixed top-6 right-6 z-50 animate-slide-in">
            <div class="bg-green-50 border border-green-200 rounded-xl p-4 shadow-lg flex items-center space-x-3">
                <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                    <span class="iconify text-xl" data-icon="ri:checkbox-circle-fill"></span>
                </div>
                <div>
                    <p class="font-medium text-green-800">咨询提交成功！</p>
                    <p class="text-sm text-green-600">我们将尽快与您联系</p>
                </div>
            </div>
        </div>



        <!-- 三法详情弹窗 -->
        <!-- 弹窗遮罩层 -->
        <div v-if="showMethodModal" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 animate-fade-in"
            @click="closeMethodModal"></div>

        <!-- 成本法详情弹窗 -->
        <div v-if="activeMethod === 'cost'"
            class="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-white rounded-2xl z-50 shadow-2xl animate-slide-up max-h-[90vh] overflow-y-auto hide-scrollbar">
            <div class="p-8">
                <div class="flex justify-between items-center mb-6">
                    <h3 class="text-2xl font-bold text-slate-900 flex items-center">
                        <span class="w-2 h-8 bg-blue-500 rounded-full mr-3"></span>
                        成本法计算评价细则
                    </h3>
                    <button class="text-slate-400 hover:text-slate-600 transition-colors" @click="closeMethodModal">
                        <span class="iconify w-8 h-8" data-icon="heroicons:x-mark"></span>
                    </button>
                </div>
                <div class="space-y-6">
                    <section>
                        <h4 class="text-sm font-bold text-slate-400 uppercase tracking-widest mb-3">核心计算公式</h4>
                        <div
                            class="bg-slate-50 p-4 rounded-xl border border-slate-100 font-mono text-lg text-center text-blue-600">
                            P = C × δ
                        </div>
                        <p class="text-xs text-slate-500 mt-2 text-center">其中 C（重置成本） = 直接成本 + 间接成本；δ 为价值调整系数 (Kq)</p>
                    </section>
                    <section class="grid grid-cols-2 gap-4">
                        <div class="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                            <h5 class="font-bold text-blue-700 text-sm mb-2">直接成本</h5>
                            <ul class="text-xs text-slate-600 space-y-1">
                                <li>• 数据采购费</li>
                                <li>• 专项人力成本 (市场价)</li>
                                <li>• 软件许可费</li>
                            </ul>
                        </div>
                        <div class="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                            <h5 class="font-bold text-blue-700 text-sm mb-2">间接成本</h5>
                            <ul class="text-xs text-slate-600 space-y-1">
                                <li>• 硬件折旧分摊</li>
                                <li>• 云资源服务费</li>
                                <li>• 数据中台运维费</li>
                            </ul>
                        </div>
                    </section>
                    <section>
                        <h4 class="text-sm font-bold text-slate-400 mb-3 uppercase tracking-widest">质量调整系数 (Kq) 映射</h4>
                        <div class="bg-white border border-slate-200 rounded-xl overflow-hidden">
                            <table class="w-full text-sm">
                                <thead class="bg-slate-50 text-slate-500">
                                    <tr>
                                        <th class="py-2 px-4 text-left">评价维度</th>
                                        <th class="py-2 px-4 text-left">权重</th>
                                        <th class="py-2 px-4 text-right">分值占比</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-slate-100">
                                    <tr>
                                        <td class="py-2 px-4">准确性/一致性</td>
                                        <td class="py-2 px-4">30%</td>
                                        <td class="py-2 px-4 text-right">1.50</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 px-4">完整性</td>
                                        <td class="py-2 px-4">20%</td>
                                        <td class="py-2 px-4 text-right">1.00</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 px-4">规范/时效性</td>
                                        <td class="py-2 px-4">25%</td>
                                        <td class="py-2 px-4 text-right">0.75</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 px-4 text-blue-600 font-bold">总计 (S)</td>
                                        <td class="py-2 px-4 font-bold">-</td>
                                        <td class="py-2 px-4 text-right font-bold text-blue-600">满分 5.0</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p class="text-xs text-slate-400 mt-3">系数公式: Kq = 0.7 + 0.3 × (S/100) | 避免质量极差造成评估归零</p>
                    </section>
                    <div class="pt-4">
                        <button
                            class="w-full py-3 bg-blue-500 text-white font-bold rounded-xl shadow-lg shadow-blue-200 hover:bg-blue-600 transition-colors"
                            @click="closeMethodModal">确认并关闭</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 收益法详情弹窗 -->
        <div v-if="activeMethod === 'revenue'"
            class="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-white rounded-2xl z-50 shadow-2xl animate-slide-up max-h-[90vh] overflow-y-auto hide-scrollbar">
            <div class="p-8">
                <div class="flex justify-between items-center mb-6">
                    <h3 class="text-2xl font-bold text-slate-900 flex items-center">
                        <span class="w-2 h-8 bg-emerald-500 rounded-full mr-3"></span>
                        收益法评估模型
                    </h3>
                    <button class="text-slate-400 hover:text-slate-600 transition-colors" @click="closeMethodModal">
                        <span class="iconify w-8 h-8" data-icon="heroicons:x-mark"></span>
                    </button>
                </div>
                <div class="space-y-6">
                    <section>
                        <h4 class="text-sm font-bold text-slate-400 uppercase tracking-widest mb-3">预期收益折现公式</h4>
                        <div
                            class="bg-slate-50 p-4 rounded-xl border border-slate-100 font-mono text-lg text-center text-emerald-600">
                            P = Σ [Fi / (1 + r)ⁱ]
                        </div>
                    </section>
                    <div class="grid grid-cols-1 gap-4">
                        <div class="border border-emerald-100 rounded-xl p-4 bg-emerald-50/30">
                            <div class="flex items-start mb-2">
                                <span
                                    class="bg-emerald-500 text-white text-[10px] py-1 px-2 rounded-md mr-3 mt-1">Fi</span>
                                <div>
                                    <h5 class="font-bold text-slate-800 text-sm">预期收益额</h5>
                                    <p class="text-xs text-slate-500 mt-1 leading-relaxed">
                                        可采用增量收益法（有无对比）、超额收益法（剔除固产贡献）或收益分成法（基于Kc贡献率）。</p>
                                </div>
                            </div>
                            <div class="flex items-start mb-2">
                                <span
                                    class="bg-emerald-500 text-white text-[10px] py-1 px-2 rounded-md mr-3 mt-1">r</span>
                                <div>
                                    <h5 class="font-bold text-slate-800 text-sm">折现率 (Discount Rate)</h5>
                                    <p class="text-xs text-slate-500 mt-1">r = WACC + β_data。数据资产特有风险溢价通常在 2%-8% 之间。</p>
                                </div>
                            </div>
                            <div class="flex items-start">
                                <span
                                    class="bg-emerald-500 text-white text-[10px] py-1 px-2 rounded-md mr-3 mt-1">i</span>
                                <div>
                                    <h5 class="font-bold text-slate-800 text-sm">收益期限</h5>
                                    <p class="text-xs text-slate-500 mt-1">综合技术迭代周期、业务生命周期判定，通常建议不超过 3-5 年。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                        <p class="text-xs text-yellow-700 font-medium">适用场景：金融风控评分模型、具备明确付费用户的API接口、商业化大数据看板等。</p>
                    </div>
                    <div class="pt-4">
                        <button
                            class="w-full py-3 bg-emerald-500 text-white font-bold rounded-xl shadow-lg shadow-emerald-200 hover:bg-emerald-600 transition-colors"
                            @click="closeMethodModal">确认并关闭</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 市场法详情弹窗 -->
        <div v-if="activeMethod === 'market'"
            class="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-white rounded-2xl z-50 shadow-2xl animate-slide-up max-h-[90vh] overflow-y-auto hide-scrollbar">
            <div class="p-8">
                <div class="flex justify-between items-center mb-6">
                    <h3 class="text-2xl font-bold text-slate-900 flex items-center">
                        <span class="w-2 h-8 bg-purple-500 rounded-full mr-3"></span>
                        市场法对比修正解析
                    </h3>
                    <button class="text-slate-400 hover:text-slate-600 transition-colors" @click="closeMethodModal">
                        <span class="iconify w-8 h-8" data-icon="heroicons:x-mark"></span>
                    </button>
                </div>
                <div class="space-y-6">
                    <section>
                        <h4 class="text-sm font-bold text-slate-400 uppercase tracking-widest mb-3">修正乘积模型</h4>
                        <div
                            class="bg-slate-50 p-4 rounded-xl border border-slate-100 font-mono text-lg text-center text-purple-600">
                            P = Σ (Qi × Xi1 × Xi2 × Xi3 × Xi4)
                        </div>
                    </section>
                    <div class="grid grid-cols-2 gap-4">
                        <div class="p-4 border border-purple-100 rounded-xl bg-purple-50/30">
                            <div class="text-purple-600 text-xs font-bold mb-1">Xi1 - 质量系数</div>
                            <p class="text-[11px] text-slate-500">对比参照物与目标物的Kq系数比 $(K_t/K_comp)$</p>
                        </div>
                        <div class="p-4 border border-purple-100 rounded-xl bg-purple-50/30">
                            <div class="text-purple-600 text-xs font-bold mb-1">Xi2 - 稀缺系数</div>
                            <p class="text-[11px] text-slate-500">根据资产壁垒设定（0.5-1.5），高壁垒数据乘数更高</p>
                        </div>
                        <div class="p-4 border border-purple-100 rounded-xl bg-purple-50/30">
                            <div class="text-purple-600 text-xs font-bold mb-1">Xi3 - 期日系数</div>
                            <p class="text-[11px] text-slate-500">根据行业价格指数或CPI调整交易日价格差异</p>
                        </div>
                        <div class="p-4 border border-purple-100 rounded-xl bg-purple-50/30">
                            <div class="text-purple-600 text-xs font-bold mb-1">Xi4 - 容量系数</div>
                            <p class="text-[11px] text-slate-500">$(V_{target}/V_{comp})^{0.2}$，规模效应遵循边际递减原则</p>
                        </div>
                    </div>
                    <div class="bg-slate-50 rounded-xl p-4 border border-slate-200">
                        <h5 class="text-xs font-bold text-slate-400 uppercase mb-2">典型示例及限制范围</h5>
                        <div class="flex justify-around items-center">
                            <div class="text-center">
                                <p class="text-xs text-slate-400">质量调整范围</p>
                                <p class="text-md font-bold text-slate-800">0.5 - 1.5</p>
                            </div>
                            <div class="h-8 w-px bg-slate-200"></div>
                            <div class="text-center">
                                <p class="text-xs text-slate-400">期日波动限值</p>
                                <p class="text-md font-bold text-slate-800">0.9 - 1.1</p>
                            </div>
                            <div class="h-8 w-px bg-slate-200"></div>
                            <div class="text-center">
                                <p class="text-xs text-slate-400">最小参考案例数</p>
                                <p class="text-md font-bold text-slate-800">≥ 3 个</p>
                            </div>
                        </div>
                    </div>
                    <div class="pt-4">
                        <button
                            class="w-full py-3 bg-purple-500 text-white font-bold rounded-xl shadow-lg shadow-purple-200 hover:bg-purple-600 transition-colors"
                            @click="closeMethodModal">确认并关闭</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/page/downloadFile" :can-download="true" />
    </div>
</template>

<script>
// 引入 ECharts
import * as echarts from 'echarts';
import FilePreview from '@/components/FilePreview.vue';

export default {
    name: 'website-valuation',
    components: {
        FilePreview
    },
    data() {
        return {
            chartInstance: null,
            // 新增：留言弹框相关数据
            showMessageModal: false,
            showSuccessToast: false,
            isSubmitting: false,
            messageForm: {
                name: '',
                contact: '',
                company: '',
                content: ''
            },
            scrollTop: 0,

            // 新增：三法弹窗相关数据
            showMethodModal: false,
            activeMethod: null, // 'cost', 'revenue', 'market'
        }
    },
    mounted() {
        // 修复：调用方法需要加括号
        this.$nextTick(() => {
            setTimeout(() => {
                this.echartsInit();
            }, 50);
        });
        // this.echartsInit();
    },
    beforeUnmount() {
        // 清理图表实例，防止内存泄漏
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    },
    methods: {
        // 饼图初始化
        echartsInit() {
            var chartDom = document.getElementById('chart-pie');
            if (!chartDom) {
                console.error('找不到图表容器: chart-pie');
                return;
            }

            // 销毁现有实例
            if (this.chartInstance) {
                this.chartInstance.dispose();
            }

            this.chartInstance = echarts.init(chartDom);
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                legend: {
                    top: '5%',
                    left: 'center',
                    textStyle: { fontSize: 12 }
                },
                // 修改：增加图表内边距，让饼图更靠近底部
                grid: {
                    top: 10,
                    bottom: 40,
                    left: 10,
                    right: 10
                },
                series: [
                    {
                        name: '评估维度权重',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // 修改：调整饼图位置，向下移动
                        center: ['50%', '61%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 16,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 35, name: '数据质量 (完整/准确/及时)', itemStyle: { color: '#1565C0' } },
                            { value: 30, name: '经济收益 (未来流量预测)', itemStyle: { color: '#00BFA5' } },
                            { value: 20, name: '市场认可 (稀缺/合规程度)', itemStyle: { color: '#7E57C2' } },
                            { value: 15, name: '治理投入 (重置成本核算)', itemStyle: { color: '#FF9800' } }
                        ]
                    }
                ]
            };
            this.chartInstance.setOption(option);

            // 响应式 Resize
            window.addEventListener('resize', () => {
                this.chartInstance.resize();
            });
        },

        // 判断文件是否可以预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },
        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },
        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },

        handleApply() {
            this.$router.push('/index/home');

        },
       async submitMessage() {
            if (this.isSubmitting) return;

            this.isSubmitting = true;

            try {
                // 构建咨询数据
                const consultationData = {
                    name: this.messageForm.name,
                    contact: this.messageForm.contact,
                    problemDescription: this.messageForm.content,
                    subjectName: this.messageForm.company || '未填写',
                    consultationTime: this.getCurrentTime(),
                    status: 0 // 默认未处理
                };

                console.log('提交咨询请求参数:', consultationData);

                // 调用API接口
                const response = await this.$axios.post('/web/consultation/save', consultationData);
                console.log('提交咨询响应:', response.data);

                if (response.data && response.data.status === 200) {
                    // 显示成功提示
                    this.showSuccessToast = true;

                    // 重置表单
                    this.messageForm = {
                        name: '',
                        contact: '',
                        company: '',
                        content: ''
                    };

                    // 关闭弹窗
                    this.showMessageModal = false;

                    // 3秒后自动隐藏成功提示
                    setTimeout(() => {
                        this.showSuccessToast = false;
                    }, 3000);
                } else {
                    this.$message.error(response.data?.msg || '提交咨询失败');
                }

            } catch (error) {
                console.error('提交咨询失败:', error);
                this.$message.error('提交咨询失败，请稍后重试');
            } finally {
                this.isSubmitting = false;
            }
        },

        // 获取当前时间（新增方法）
        getCurrentTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 新增：打开三法详情弹窗
        openMethodModal(method) {
            this.activeMethod = method;
            this.showMethodModal = true;
            document.body.classList.add('overflow-hidden');
        },

        // 新增：关闭三法详情弹窗
        closeMethodModal() {
            this.showMethodModal = false;
            this.activeMethod = null;
            document.body.classList.remove('overflow-hidden');
        },
    }
}
</script>

<style lang="scss" scoped>
// 确保图表容器有明确的尺寸
#chart-pie {
    width: 100%;
    height: 320px; // 增加高度确保可见
    min-height: 320px;
}

.hide-scrollbar::-webkit-scrollbar {
    display: none;
}

.hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

html {
    scroll-behavior: smooth;
}

.hero-gradient {
    background: linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%);
}


// 弹窗动画
.fixed.inset-0 {
    animation: fadeIn 0.3s ease-out;

    .bg-white {
        animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
}

// 成功提示动画
.animate-slide-in {
    animation: slideInRight 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(100%);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

// 响应式调整
@media (max-width: 768px) {

    // 弹窗响应式
    .fixed.inset-0 {
        padding: 1rem;
        align-items: flex-end;

        .bg-white {
            width: 100%;
            max-width: 100%;
            border-radius: 1rem 1rem 0 0;
            animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    @keyframes slideUpMobile {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    // 成功提示响应式
    .fixed.top-6.right-6 {
        top: auto;
        bottom: 1rem;
        right: 1rem;
        left: 1rem;
        animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
}

// 平板设备适配
@media (min-width: 769px) and (max-width: 1024px) {
    .fixed.inset-0 {
        .bg-white {
            max-width: 90%;
        }
    }
}


// 评估方法体系卡片样式
.method-cards-container {
    .method-card {
        background: white;
        border-radius: 1rem;
        overflow: hidden;
        border: 1px solid #e5e7eb;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        display: flex;
        flex-direction: column;

        // 基础阴影效果
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05),
            0 2px 4px -1px rgba(0, 0, 0, 0.03);

        // 边框发光效果
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 1rem;
            border: 1px solid transparent;
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.2)) border-box;
            -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        // 悬停效果
        &:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
                0 10px 10px -5px rgba(0, 0, 0, 0.04);

            &::before {
                opacity: 1;
            }
        }

        // 顶部装饰条
        .h-2 {
            position: relative;
            overflow: hidden;

            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
                transition: left 0.6s ease;
            }
        }

        &:hover .h-2::after {
            left: 100%;
        }
    }

    // 按钮基础样式
    .method-btn {
        display: block;
        text-align: center;
        padding: 0.5rem 1rem;
        border-radius: 0.375rem;
        font-weight: 500;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        z-index: 1;
        border: 1px solid;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
            transition: left 0.6s ease;
            z-index: -1;
        }

        &:hover::before {
            left: 100%;
        }
    }

    // 成本法按钮
    .cost-btn {
        color: #3b82f6;
        border-color: #3b82f6;
        background-color: white;

        &:hover {
            background-color: #3b82f6;
            color: white;
            border-color: #3b82f6;
        }
    }

    // 收益法按钮
    .revenue-btn {
        color: #10b981;
        border-color: #10b981;
        background-color: white;

        &:hover {
            background-color: #10b981;
            color: white;
            border-color: #10b981;
        }
    }

    // 市场法按钮
    .market-btn {
        color: #8b5cf6;
        border-color: #8b5cf6;
        background-color: white;

        &:hover {
            background-color: #8b5cf6;
            color: white;
            border-color: #8b5cf6;
        }
    }

    // 成本法卡片特殊样式
    .cost-method {
        &:hover {
            border-color: #3b82f6;

            .h-2 {
                box-shadow: 0 0 20px rgba(59, 130, 246, 0.4);
            }
        }

        &::before {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(59, 130, 246, 0.05)) border-box;
        }
    }

    // 收益法卡片特殊样式
    .revenue-method {
        &:hover {
            border-color: #10b981;

            .h-2 {
                box-shadow: 0 0 20px rgba(16, 185, 129, 0.4);
            }
        }

        &::before {
            background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(16, 185, 129, 0.05)) border-box;
        }
    }

    // 市场法卡片特殊样式
    .market-method {
        &:hover {
            border-color: #8b5cf6;

            .h-2 {
                box-shadow: 0 0 20px rgba(139, 92, 246, 0.4);
            }
        }

        &::before {
            background: linear-gradient(135deg, rgba(139, 92, 246, 0.1), rgba(139, 92, 246, 0.05)) border-box;
        }
    }

    // 卡片内容区域悬停效果增强
    .method-card:hover {
        .text-xl {
            transform: translateX(4px);
            transition: transform 0.3s ease;
        }
    }

    // 响应式调整
    @media (max-width: 768px) {
        .method-card {
            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
                    0 4px 6px -2px rgba(0, 0, 0, 0.05);
            }
        }
    }


}

// 价值应用场景卡片样式 
.value-scene-container {
    .value-scene-card {
        background: white;
        padding: 2.5rem;
        border-radius: 1.5rem;
        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05),
            0 5px 10px -5px rgba(0, 0, 0, 0.02);
        border: 1px solid #f1f5f9;
        transition: all 0.3s ease;

        // 卡片悬停效果
        &:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.12);

            // 图标放大效果
            .w-14 {
                transform: scale(1.1);
                box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15);
            }

            // 标题移动效果
            h3 {
                transform: translateX(5px);
            }

            // 描述文字显示更多
            p.line-clamp-3 {
                -webkit-line-clamp: 5;
                line-clamp: 5;
            }

            // 特性列表上浮
            ul {
                transform: translateY(-3px);
                box-shadow: 0 8px 20px -5px rgba(0, 0, 0, 0.08);
            }
        }

        // 图标过渡
        .w-14 {
            transition: all 0.3s ease;
        }

        // 标题过渡
        h3 {
            transition: transform 0.3s ease;
        }

        // 描述文字过渡
        p.line-clamp-3 {
            transition: all 0.3s ease;
            min-height: 4.5rem;
        }

        // 特性列表过渡
        ul {
            transition: all 0.3s ease;
        }
    }

    // 场景1 - 蓝色主题
    .scene-1 {
        &:hover {
            border-color: #3b82f6;
            background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
        }
    }

    // 场景2 - 绿色主题
    .scene-2 {
        &:hover {
            border-color: #10b981;
            background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
        }
    }

    // 场景3 - 紫色主题
    .scene-3 {
        &:hover {
            border-color: #8b5cf6;
            background: linear-gradient(135deg, #ffffff 0%, #faf5ff 100%);
        }
    }

    // 响应式调整
    @media (max-width: 768px) {
        .value-scene-card {
            padding: 1.5rem;

            &:hover {
                transform: translateY(-4px);
            }
        }
    }

}
</style>